import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { ApiService } from '../api/api.service';
import { ShopTypeEnum } from '../enums/shop-type';

@Injectable({
  providedIn: 'root',
})
export class PublishProductsAccessGuard implements CanActivate {

  constructor(
    private router: Router,
    private api: ApiService
  ) { }

  async canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const shops = (await this.api.shops.searchAsync({
        itemsPerPage: 1,
        pageNumber: 1
      })).items;

      const currentShop = shops && shops.length > 0 ? shops[0] : undefined;
      if (currentShop?.type === ShopTypeEnum.Shopify ||
        currentShop?.type === ShopTypeEnum.Lightspeed ||
        currentShop?.type === ShopTypeEnum.LightspeedX) {
        return true;
      }
    } catch {
      // No-op: if shop lookup fails, deny access and redirect.
    }

    this.router.navigate(['/']);
    return false;
  }
}
